import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Cookies from "js-cookie";
import { InputMask } from "primereact/inputmask";
import { Icon } from "@iconify/react/dist/iconify.js";
import { CONTACTAGENTLIST_URL, CREATE_LEAD_URL, DELETECONTACTAGENT_URL } from "../../global/API";

import CustomModal from "../../components/customModal/customModal";

const Contacts = () => {
  const [contactList, setContactList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [paginationObj, setPaginationObj] = useState({ pageSize: 30, current: 1 });
  const [filteredValues, setFilteredValues] = useState({ searchValue: "" });
  const [selectedContact, setSelectedContact] = useState([]);
  const [editContact, setEditContact] = useState({});

  const navigate = useNavigate();
  const { pathname } = useLocation();

  const fetchData = async (current, pageSize = paginationObj.pageSize) => {
    const { searchValue } = filteredValues;
    setIsLoading(true);
    const jwtToken = Cookies.get("jwtToken");
    const options = {
      method: "GET",
      headers: { Authorization: `Bearer ${jwtToken}` },
    };
    const URL = CONTACTAGENTLIST_URL + `?type=1,2&limit=${pageSize}&page=${current}&search=${searchValue}`;
    try {
      const response = await fetch(URL, options);
      if (response.ok) {
        const data = await response.json();
        setContactList(data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const jwtToken = Cookies.get("jwtToken");
        const options = {
          method: "GET",
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        };

        try {
          const response = await fetch(DELETECONTACTAGENT_URL + `${id}`, options);
          if (response.ok) {
            Swal.fire({
              title: "Deleted!",
              text: "Your file has been deleted.",
              icon: "success",
            });
            fetchData(paginationObj.current, paginationObj.pageSize);
          } else {
            console.error("Failed to delete contact");
          }
        } catch (error) {
          console.error("Error deleting contact:", error);
        }
      }
    });
  };

  const onHandleselectedList = (id, event) => {
    const newList = id;
    if (event.target.checked) {
      setSelectedContact((preState) => [...preState, newList]);
    } else {
      const filteredListing = selectedContact.filter((item) => item !== id);
      setSelectedContact(filteredListing);
    }
  };

  const onHandleEvent = (event) => {
    const { name, value } = event.target;
    setEditContact((previousState) => ({ ...previousState, [name]: value }));
  };

  const onHandleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    Object.entries(editContact).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        formData.append(key, value);
      }
    });

    try {
      const jwtToken = Cookies.get("jwtToken");
      const options = {
        method: "POST",
        body: formData,
        headers: { Authorization: `Bearer ${jwtToken}`, Accept: "application/json" },
      };
      const response = await fetch(CREATE_LEAD_URL + selectedContact[0], options);
      const data = await response.json();
      if (data.status === "Success") {
        setSelectedContact([]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData(paginationObj.current, paginationObj.pageSize);
  }, [paginationObj]);

  useEffect(() => {
    const { searchValue } = filteredValues;

    if (searchValue.length >= 3 || searchValue === "") {
      const timeout = setTimeout(() => {
        fetchData(1, paginationObj.pageSize);
      }, 300);
      return () => clearTimeout(timeout);
    }
  }, [filteredValues.searchValue]);

  const filterGrid = (e) => {
    const { name, value } = e.target;
    setFilteredValues({
      ...filteredValues,
      [name]: value,
    });
  };

  const paginationChange = (current, pageSize) => {
    setPaginationObj({ ...paginationObj, current });
    fetchData(current, pageSize);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  function formatUSPhoneNumber(number) {
    const cleaned = ("" + number).replace(/\D/g, "");
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

    if (match) {
      return `(${match[1]}) ${match[2]} ${match[3]}`;
    }

    return number;
  }

  const contactListView = () => {
    return contactList.data.map((contacts) => {
      const { id, listing_id, property_address, name, phone, email, message, updated_at, type } = contacts;
      const date = new Date(updated_at);
      const formatted = date.toLocaleString("en-US", {
        year: "numeric",
        month: "short",
        day: "2-digit",
        // hour: "2-digit",
        // minute: "2-digit",
      });
      // const formatted = `${String(date.getUTCDate()).padStart(2, "0")}-${String(date.getUTCMonth() + 1).padStart(2, "0")}-${date.getUTCFullYear()}`;
      return (
        <tr key={id}>
          <td style={{ width: "10px", paddingRight: "0" }}>
            <div className="form-check">
              <input type="checkbox" className="form-check-input" onChange={(e) => onHandleselectedList(id, e)} checked={selectedContact.includes(id)} />
              <label className="form-check-label"></label>
            </div>
          </td>
          <td>
            <div className="d-flex align-items-center gap-2 item-overflow-2">
              <a href="#!" className="text-dark fw-medium fs-15">
                {name}
              </a>
            </div>
          </td>
          <td>{email}</td>
          <td>{formatUSPhoneNumber(phone)}</td>
          <td>
            <div className="d-flex align-items-center gap-2 item-overflow">
              <div>
                <Link to={`/property-details/${listing_id}`} className="text-dark ">
                  {property_address}
                </Link>
              </div>
            </div>
          </td>
          <td>
            <span>{message}</span>
          </td>
          <td>{formatted}</td>
        </tr>
      );
    });
  };

  const contactsLoadingView = () => {
    return (
      <tr className="loading-hover">
        <td className="property-loader preloader">
          <div className="loading">
            <div className="loading__letter">L</div>
            <div className="loading__letter">o</div>
            <div className="loading__letter">a</div>
            <div className="loading__letter">d</div>
            <div className="loading__letter">i</div>
            <div className="loading__letter">n</div>
            <div className="loading__letter">g</div>
            <div className="loading__letter">.</div>
            <div className="loading__letter">.</div>
            <div className="loading__letter">.</div>
          </div>
        </td>
      </tr>
    );
  };

  const noContatcsView = () => {
    return (
      <tr className="loading-hover">
        <td className="no-data-found">
          <Icon icon="solar:home-broken" className="fs-32 text-primary avatar-title"></Icon>
          No Contact Found
        </td>
      </tr>
    );
  };

  const renderView = () => {
    if (isLoading) {
      return contactsLoadingView();
    } else if (contactList.status === "Not Found") {
      return noContatcsView();
    } else if (contactList.status === "Success") {
      return contactListView();
    }
  };

  const renderContactEditing = () => {
    const { name, email, phone, message } = editContact;

    return (
      <form onSubmit={onHandleSubmit}>
        <div className="mb-3">
          <label className="form-label">Name</label>
          <input type="name" name="name" onChange={onHandleEvent} className="form-control" value={name} />
        </div>
        <div className="mb-3">
          <label className="form-label">Email</label>
          <input type="email" name="email" onChange={onHandleEvent} className="form-control" value={email} />
        </div>
        <div className="mb-3">
          <label className="form-label">Phone</label>
          <InputMask mask="(999) 999 9999" name="phone" value={phone} onChange={onHandleEvent} placeholder="(123) 456-7890" className="form-control" />
        </div>
        <div className="mb-3">
          <label className="form-label">Message</label>
          <textarea name="message" className="form-control" rows="6" value={message} onChange={onHandleEvent}></textarea>
        </div>
        <div className="page-title-box">
          <button type="submit" className="btn btn-primary btn-blue">
            Submit
          </button>
        </div>
      </form>
    );
  };

  return (
    <div className="page-content leads-page">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">All Contacts ({contactList.pagination !== undefined ? contactList.pagination.total : 0})</h4>

              <div className="page-title-box-content">
                {selectedContact.length > 0 && (
                  <button type="button" className="page-title-btn custom-target-icon fs-18" onClick={() => handleDelete(selectedContact)}>
                    <i className="ri-delete-bin-line"></i>
                  </button>
                )}
                {selectedContact.length === 1 && (
                  <button
                    type="button"
                    className="page-title-btn custom-target-icon fs-18"
                    onClick={() => {
                      navigate(`edit/${selectedContact[0]}`);
                      const selectedTeamData = contactList.data.filter((lead) => lead.id === selectedContact[0])[0];
                      setEditContact(selectedTeamData);
                    }}
                  >
                    <i className="ri-edit-2-line"></i>
                  </button>
                )}
                <button
                  type="button"
                  className="refresh-button"
                  title="Reset"
                  onClick={() => {
                    setFilteredValues({
                      searchValue: "",
                    });
                  }}
                >
                  <i className="ri-refresh-line"></i>
                </button>

                <form className="app-search">
                  <div className="position-relative">
                    <input type="search" className="form-control border-0" placeholder="Search..." autoComplete="off" value={filteredValues.searchValue} onChange={filterGrid} name="searchValue" />
                    <i className="ri-search-line search-widget-icon"></i>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="table-responsive">
                <table className="table align-middle text-nowrap table-hover table-centered property-table">
                  <thead className="bg-light-subtle">
                    <tr>
                      <th style={{ width: "10px" }}>
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            onChange={(e) => {
                              if (e.target.checked) {
                                setSelectedContact(contactList.data.map((lead) => lead.id));
                              } else {
                                setSelectedContact([]);
                              }
                            }}
                            checked={contactList?.data?.length > 0 && selectedContact.length === contactList.data.length}
                          />
                          <label className="form-check-label"></label>
                        </div>
                      </th>

                      <th>Name</th>
                      <th>Email</th>
                      <th>Phone</th>
                      <th>Property Name</th>
                      <th>Message</th>
                      <th>Created Date</th>
                    </tr>
                  </thead>
                  <tbody>{renderView()}</tbody>
                </table>
                <div className="modal fade filter-model" id="contactDetail" aria-labelledby="contactDetailLabel" aria-hidden="true">
                  <div className="modal-dialog">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h1 className="modal-title fs-5" id="contactDetailLabel">
                          Contact Details
                        </h1>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                      </div>
                      <div className="modal-body">
                        {selectedContact ? (
                          <div className="contact-details">
                            <p>
                              <strong className="view-title">Name:</strong> {selectedContact.name}
                            </p>
                            <p>
                              <strong className="view-title">Email:</strong> {selectedContact.email}
                            </p>
                            <p>
                              <strong className="view-title">Phone:</strong> {selectedContact.phone}
                            </p>
                            <p>
                              <strong className="view-title">Property Address:</strong>
                              <br />
                              {selectedContact.property_address}
                            </p>
                            <p>
                              <strong className="view-title">Date:</strong> {new Date(selectedContact.updated_at).toLocaleDateString("en-GB")}
                            </p>
                            <p>
                              <strong className="view-title">Message:</strong>
                              <br />
                              {selectedContact.message}
                            </p>
                          </div>
                        ) : (
                          <p>No contact selected.</p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {selectedContact.length === 1 && (
          <CustomModal renderItem={renderContactEditing} title="Edit Contact" showHeader={true} position="right" visible={pathname.toLowerCase().includes(`edit/${selectedContact[0]}`)} />
        )}

        <div className="pagination-grid">
          <div className="pagination-new">
            <span className="pagination-count">
              {contactList.pagination !== undefined ? contactList.pagination.from : 1}-{contactList.pagination !== undefined ? contactList.pagination.to : 6} &nbsp;of &nbsp;
              {contactList.pagination !== undefined ? contactList.pagination.total : 0}
            </span>

            <button
              type="button"
              className="pagination-btn pagination-prev"
              onClick={() => {
                setPaginationObj((prevState) => ({ ...prevState, current: prevState.current - 1 }));
              }}
              disabled={paginationObj.current === 1}
            >
              <i className="ri-arrow-left-s-line"></i>
            </button>
            <button
              type="button"
              className="pagination-btn pagination-next"
              onClick={() => {
                setPaginationObj((prevState) => ({ ...prevState, current: prevState.current + 1 }));
              }}
              disabled={paginationObj.current === contactList?.pagination?.last_page}
            >
              <i className="ri-arrow-right-s-line"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contacts;
